import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { ddfList } from "../placeholder";
import Form from "../partials/Form";
import classNames from "classnames";
import Vote from "../partials/Vote";
import Wrapper from "../components/Wrapper";
import { confirmWallet } from "../redux/actions/modal";
import { useDispatch, useSelector } from "react-redux";

export default function () {
  const [queued, setQueued] = useState([]);
  const [executed, setExecuted] = useState([]);
  const confirmed = useSelector((state) => state.app.wallet.check);
  const dispatch = useDispatch();

  const walletChecker = (e) => {
    e.preventDefault();

    if (confirmed !== true) {
      dispatch(confirmWallet({ isCheck: true }));
    }
  };

  const queueHandler = (id) => {
    const newQueue = queued.map((item, index) => {
      if (index === id) {
        return { ...item, checked: !item.checked };
      }
      return item;
    });

    setQueued(newQueue);
  };

  const executeHandler = (id) => {
    const newExecute = executed.map((item, index) => {
      if (index === id) {
        return { ...item, checked: !item.checked };
      }
      return item;
    });

    setExecuted(newExecute);
  };

  useEffect(() => {
    const queue = JSON.parse(JSON.stringify(ddfList)).map((item) => ({
      ...item,
      checked: false,
    }));
    const execute = JSON.parse(JSON.stringify(ddfList)).map((item) => ({
      ...item,
      checked: false,
    }));

    setQueued(queue);
    setExecuted(execute);
  }, []);

  return (
    <div className="dao dao_big">
      <Vote title="Product Voting" subtitle="Aggregate Yes Rate: XX">
        <div className="v-form-item v-form-item_title">
          <div className="v-form-item__col v-form-item__col_checkbox"></div>
          <div className="v-form-item__col v-form-item__col_product">
            <p className="v-form-item__title-text">Product</p>
          </div>
          <div className="v-form-item__col v-form-item__col_info">
            <p className="v-form-item__title-text">Link to Submission Form</p>
          </div>
          <div className="v-form-item__col v-form-item__col_status">
            <p className="v-form-item__title-text">Proposal Status</p>
          </div>
        </div>
        <Wrapper className="v-form__list-items" showItems={4} marginTop={21}>
          {queued.map((vote) => (
            <div
              className={classNames("v-form-item block-view", {
                "v-form-item_orange": vote.queued,
              })}
            >
              <div className="v-form-item__col v-form-item__col_checkbox">
                <label
                  htmlFor={`queued-${vote.id}`}
                  className="v-form__label"
                  onChange={queueHandler.bind(null, vote.id)}
                >
                  <input
                    type="checkbox"
                    name="check-test"
                    id={`queued-${vote.id}`}
                    checked={vote.checked}
                    className="v-form__hidden"
                  />
                  <div className="v-form__checkbox"></div>
                </label>
              </div>
              <div className="v-form-item__col v-form-item__col_product">
                <p className="v-form__product">{vote.product}</p>
              </div>
              <div className="v-form-item__col v-form-item__col_info">
                <a href="/ss" className="v-form__info-link">
                  {vote.form.link}
                </a>
                <div className="v-form__under-info">
                  <span className="v-form__info-submitted">
                    {vote.form.submitted ? "Submitted" : "Not submitted"}
                  </span>
                  <span className="v-form__info-date">{vote.form.date}</span>
                  <span className="v-form__info-rate">
                    Yes Rate: <strong>{vote.form.rate}</strong>
                  </span>
                </div>
              </div>
              <div className="v-form-item__col v-form-item__col_status">
                {vote.queued ? (
                  <div className="v-form__status v-form__status_orange">
                    Queued
                  </div>
                ) : (
                  <div className="v-form__status v-form__status_blue">
                    Approved
                  </div>
                )}
              </div>
              <NavLink
                className="v-form-item__link"
                to={`/dao/product-voiting/${vote.id}`}
              ></NavLink>
            </div>
          ))}
        </Wrapper>
        <Form.Submit onClick={walletChecker} className="v-form__submit-btn">
          Submit Vote
        </Form.Submit>
      </Vote>

      <Vote
        className="v-form__contin"
        title="Product Continuation Voting"
        subtitle="Product Proposal Continuation Rate:"
      >
        <div className="v-form-item v-form-item_title">
          <div className="v-form-item__col v-form-item__col_checkbox"></div>
          <div className="v-form-item__col v-form-item__col_product">
            <p className="v-form-item__title-text">Product</p>
          </div>
          <div className="v-form-item__col v-form-item__col_info">
            <p className="v-form-item__title-text">Link to Submission Form</p>
          </div>
          <div className="v-form-item__col v-form-item__col_status">
            <p className="v-form-item__title-text">Proposal Status</p>
          </div>
        </div>
        <Wrapper className="v-form__list-items" showItems={4} marginTop={21}>
          {executed.map((vote) => (
            <div
              className={classNames("v-form-item block-view", {
                "v-form-item_green": vote.executed,
              })}
            >
              <div className="v-form-item__col v-form-item__col_checkbox">
                <label
                  htmlFor={`executed-${vote.id}`}
                  className="v-form__label"
                  onChange={executeHandler.bind(null, vote.id)}
                >
                  <input
                    type="checkbox"
                    name="check-test"
                    id={`executed-${vote.id}`}
                    checked={vote.checked}
                    className="v-form__hidden"
                  />
                  <div className="v-form__checkbox"></div>
                </label>
              </div>
              <div className="v-form-item__col v-form-item__col_product">
                <p className="v-form__product">{vote.product}</p>
              </div>
              <div className="v-form-item__col v-form-item__col_info">
                <a href="/ss" className="v-form__info-link">
                  {vote.form.link}
                </a>
                <div className="v-form__under-info">
                  <span className="v-form__info-submitted">
                    {vote.form.submitted ? "Submitted" : "Not submitted"}
                  </span>
                  <span className="v-form__info-date">{vote.form.date}</span>
                  <span className="v-form__info-rate">
                    Product Proposal Continuation Rate:{" "}
                    <strong>{vote.form.rate}</strong>
                  </span>
                </div>
              </div>
              <div className="v-form-item__col v-form-item__col_status">
                <div className="v-form__status v-form__status_green">
                  Executed
                </div>
              </div>
            </div>
          ))}
        </Wrapper>
        <Form.Submit onClick={walletChecker} className="v-form__submit-btn">
          Discontinue
        </Form.Submit>
      </Vote>
    </div>
  );
}
